var React = require('react');

function PlayArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"play arrow"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"play_arrow","data-name":"play arrow"},React.createElement("path",{"d":"M6.5,53.34a6.46,6.46,0,0,1-3.28-.9A6.42,6.42,0,0,1,0,46.83V6.51A6.42,6.42,0,0,1,3.22.9,6.45,6.45,0,0,1,9.69.84L45.53,21a6.5,6.5,0,0,1,0,11.33L9.69,52.5A6.53,6.53,0,0,1,6.5,53.34ZM6.51,5a1.58,1.58,0,0,0-.77.21A1.5,1.5,0,0,0,5,6.51V46.83a1.5,1.5,0,0,0,2.24,1.31L43.08,28a1.51,1.51,0,0,0,0-2.62L7.24,5.2A1.58,1.58,0,0,0,6.51,5Z"}))))]);
}

PlayArrow.defaultProps = {"viewBox":"0 0 48.84 53.34"};

module.exports = PlayArrow;

PlayArrow.default = PlayArrow;
